var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"renderEmpty":_vm.renderEmpty,"locale":_vm.locale}},[_c('div',{staticClass:"vue-app"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }